"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (arg, name, type, required) {
    if (required === void 0) { required = true; }
    if (arg === undefined && required)
        throw new Error("Argument \"" + name + "\" is required.");
    if (arg === undefined && !required)
        return;
    if (typeof arg !== type) {
        if (type === 'array' && Array.isArray(arg))
            return;
        throw new Error("Incorrect data type on argument \"" + name + "\". Received \"" + typeof arg + "\": expected \"" + type + "\"");
    }
});
//# sourceMappingURL=checkArg.js.map